export const showTransports = (state) => state.transports
